import { render, staticRenderFns } from "./ProposalAppendix.vue?vue&type=template&id=3afb6412"
import script from "./ProposalAppendix.vue?vue&type=script&lang=js"
export * from "./ProposalAppendix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports